/* eslint-disable global-require */
/* eslint-disable max-len */

export default {
  competitionIntro: {
    paragraphLeft: {
      title: 'What is World Think Cup?',
      desc: 'World Think Cup (WTC) is initiated by the Think Academy US Branch each year in April. This event strives to provide free math resources and encourage students’ interest in math, develop their problem solving and logical thinking skills, and inspire them to excel in math and be able to make friends through the language of math.',
    },
    paragraphRight: {
      title: '2022 World Think Cup',
      desc: 'We strongly encourage students between grades 1-5 to join us for the 2022 World Think Cup. The students will have the opportunity to experience a set of challenging but fun math problems, as well as receive a prize and certificate.',
    },
    introList: [{
      label: 'Date:',
      content: 'April 23 - 24',
    }, {
      label: 'Grade:',
      content: '1-5',
    }, {
      label: 'Time:',
      content: '40 minutes',
    }, {
      label: 'Question:',
      content: '25 multiple choice questions',
    }, {
      label: 'Format:',
      content: `online via <a class="competition-intro-link" href="/download">Think Academy Student app</a> or
      <br>onsite at Cupertino, CA or Seatle, WA`,
    }],
  },
  // 竞赛奖品&获奖比例
  awardAndPrizeIntro: {
    title: 'Prizes and awards',
    awardRatioIntro: [{
      label: 'Distinguished Honor Roll: ',
      paragraph: 'Top 5% will receive Think Cup Trophy and tailored gifts.',
      color: '#FFAB00',
    }, {
      label: 'Honor Roll: ',
      paragraph: 'Top 30% will receive Think Cup Certificate and gifts.',
    }, {
      label: 'Achievement Certificate: ',
      paragraph: 'All participants will receive a certificate and a math learning analysis report based on the test result.',
    }],
    prizeIntro: {
      paragraph: 'There are a set of gifts options including but not limited to: writing tablet, LEGO sets, flashing cube, bluetooth microphone, puzzle books, etc. We will send emails to prize winners in terms of the gift details after the competition.',
      prizeList: [{
        img: require('assets/images/competition-mall/cushions.jpg'),
        desc: '',
      }, {
        img: require('assets/images/competition-mall/puzzles.jpg'),
        desc: '',
      }, {
        img: require('assets/images/competition-mall/lego.jpg'),
        desc: '',
      }, {
        img: require('assets/images/competition-mall/chessboards.jpg'),
        desc: '',
      }, {
        img: require('assets/images/competition-mall/plush-toys.jpg'),
        desc: '',
      }, {
        img: require('assets/images/competition-mall/pencil-case.jpg'),
        desc: '',
      }],
    },
  },

  // 获奖名单
  awardStudentList1: {
    header: {
      banner: require('assets/images/competition-mall/award-list-1-bg.jpg'),
      title: 'Distinguished Honor Roll',
      titleColor: '#B26D00',
      label: {
        name: 'Results · 2022',
        bgColor: '#FFAA0A',
      },
      bgColor: '#ffda58',
    },
    awardList: [{
      gradeLabel: {
        name: 'Grade 1',
        bgColor: '#FFAA0A',
      },
      studentList: ['Abby H', 'Alvin W', 'Amber Z', 'Charlotte J', 'Derek X', 'Geoffrey D', 'Hengrui Z', 'Irenee Y', 'Lili W', 'Luna L', 'Oscar H'],
    }, {
      gradeLabel: {
        name: 'Grade 2',
        bgColor: '#546CFF',
      },
      studentList: ['Adrian W', 'Aiden J', 'Allen H', 'Arnaud G', 'Brenda B', 'Chloe C', 'Jensen L', 'Maoxing K', 'Robby Q', 'Ruixuan L', 'Tong W', 'Yanchu D', 'Zhengzheng Z'],
    }, {
      gradeLabel: {
        name: 'Grade 3',
        bgColor: '#71C941',
      },
      studentList: ['Aaron G', 'Alex Y', 'Bingqian W', 'Caroline Y', 'Jason H', 'Jessica Y', 'Joel S', 'Miranda W', 'Qiaochu L', 'Yi N', 'Yining W', 'Zoey H', 'Zoey H'],
    }, {
      gradeLabel: {
        name: 'Grade 4',
        bgColor: '#FF9691',
      },
      studentList: ['Aiden Y', 'Bruce P', 'Derrick C', 'Dylan W', 'Jeremy Z', 'Justin G', 'Yichen W', 'Yiheng Y', 'Zale Z'],
    }, {
      gradeLabel: {
        name: 'Grade 5',
        bgColor: '#05DB7E',
      },
      studentList: ['Ava A', 'Elaine G', 'George J', 'Jonathan J', 'Tianhan F'],
    }],
  },
  awardStudentList2: {
    header: {
      banner: require('assets/images/competition-mall/award-list-2-bg.jpg'),
      title: 'Honor Roll',
      titleColor: '#7E9722',
      label: {
        name: 'Results · 2022',
        bgColor: '#A7C148',
      },
      bgColor: '#D3E982',
    },
    awardList: [{
      gradeLabel: {
        name: 'Grade 1',
        bgColor: '#FFAA0A',
      },
      studentList: ['Aaron W', 'Adele L', 'Alison Z', 'Alyssa S', 'Andrew G', 'Arthur L', 'Athena Z', 'Ava C', 'Beichen X', 'Carson T', 'Charlotte Y', 'Cindy A', 'Claire H', 'Clara C', 'Derek L', 'Douglas Z', 'Dylan X', 'Emily S', 'Emma Z', 'Ethan Z', 'Evelyn T', 'Gilbert G', 'Hanson M', 'James Z', 'Jason Z', 'Joshua H', 'Justin Z', 'Kimmie L', 'Leonardo K', 'Leslie W', 'Madelyn C', 'Martin W', 'Nathan Y', 'Olivia M', 'Riley X', 'Shu W', 'Stephen H', 'Tim X', 'Wenxuan H'],
    }, {
      gradeLabel: {
        name: 'Grade 2',
        bgColor: '#546CFF',
      },
      studentList: ['Alex W', 'Charles L', 'James C', 'Aaron X', 'Alex Y', 'Allan H', 'Andrew H', 'Anya S', 'Arsh G', 'Athan T', 'Austin C', 'Austin F', 'Bowen Y', 'Brian G', 'Daniel Y', 'David B', 'Derrick P', 'Di W', 'Edward H', 'Elizabeth S', 'Emma W', 'Ethan Wang', 'Evelyn J', 'Fang Y', 'Hanchen Z', 'Hannah L', 'Helen L', 'Iris L', 'Jacquelyn L', 'Jasmine Z', 'Jeremy H', 'Jonathan W', 'Lauren L', 'Marshall H', 'Michael H', 'Michael Z', 'Mitchell Z', 'Nathan J', 'Nina L', 'Qianzi H', 'Raymond J', 'Ruichen H', 'Stephanie T', 'Zach C', 'Ziqian G', 'Ziwen Z'],
    }, {
      gradeLabel: {
        name: 'Grade 3',
        bgColor: '#71C941',
      },
      studentList: ['Andrew M', 'Aiden X', 'Amy S', 'Andrew H', 'Bowen Y', 'Brian L', 'Daniel Y', 'Darren Z', 'Derek L', 'Eason L', 'Elizabeth L', 'Eric W', 'Eric Z', 'Erica C', 'Ethan X', 'Felix Z', 'Gordon W', 'James W', 'Jeremy B', 'Jonathan Y', 'Justin Y', 'Kevin C', 'Kevin Z', 'Larry L', 'Larry L', 'Lisa Z', 'Luca L', 'Lucas K', 'Luke Z', 'Lyra Y', 'Matthew W', 'Nicky G', 'Noah L', 'Oliver S', 'Qiaoxu Y', 'Ryan J', 'Ryan L', 'Ryan Q', 'Serena Y', 'Shaohao L', 'Spencer Z', 'Sunny Z', 'Tianrui X', 'Tiffany H', 'William M', 'Xingyu C', 'Yize G', 'Yujie W', 'Zanqin W', 'Zichen X'],
    }, {
      gradeLabel: {
        name: 'Grade 4',
        bgColor: '#FF9691',
      },
      studentList: ['Aaron W', 'Alicia H', 'Arthur C', 'Bowen N', 'Bryce X', 'Connie A', 'Ethan S', 'Ethan T', 'Helen X', 'Heran Z', 'Howard L', 'Irvin J', 'James C', 'Jason T', 'Jessica Y', 'Kyla H', 'Langxing C', 'Matthew W', 'Myles Z', 'Oliver S', 'Olivia X', 'Preston L', 'Qiqi M', 'Sandy W', 'Siqi W', 'Sophia C', 'Stephen L', 'Suri S', 'Xiaoyang M', 'Yvonne H', 'Zhiyue M'],
    }, {
      gradeLabel: {
        name: 'Grade 5',
        bgColor: '#05DB7E',
      },
      studentList: ['Andy L', 'Bobby Q', 'Brian L', 'Ethan C', 'Ethan Z', 'Evelyn W', 'Hannah G', 'Judy Z', 'Kaiyuan M', 'Kenneth S', 'Max L', 'Minglang L', 'Nolan L', 'Ruozhen M', 'Stella W', 'Uriah C', 'Xuejia N', 'Yufei W', 'Yukun X', 'Zimou Z'],
    }],
  },
  // 样题
  sampleQuestions: {
    title: 'Sample question',
    desc: 'World Think Cup (WTC) is initialized by Think Academy US Branch each year in April. This event is strived to provide free math resources and encourage students’ interest in math.<br>For fairness and better test experience, we highly suggest you sign up for the same grade as your kid\'s current grade at school. Each kid can only sign up for one grade.',
    questions: [{
      fileName: 'Think World Cup Grade1 Sample Question',
      fileUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/competition-sample/Think_Cup_G_1.pdf',
    }, {
      fileName: 'Think World Cup Grade2 Sample Question',
      fileUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/competition-sample/Think_Cup_G_2.pdf',
    }, {
      fileName: 'Think World Cup Grade3 Sample Question',
      fileUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/competition-sample/Think_Cup_G_3.pdf',
    }, {
      fileName: 'Think World Cup Grade4 Sample Question',
      fileUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/competition-sample/Think_Cup_G_4.pdf',
    }, {
      fileName: 'Think World Cup Grade5 Sample Question',
      fileUrl: 'https://download-pa-s3.thethinkacademy.com/static-pa/static/node_global_website_online/us/competition-sample/Think_Cup_G_5.pdf',
    }],
  },

  faq: {
    title: 'FAQs',
    faqList: [{
      que: '1. What is covered on World Think Cup?',
      ans: 'The World Think Cup is a good chance for 1st graders to 5th graders to experience their grades’ own “AMC”. We are aiming to provide all students from primary school a chance to know and feel the AMC8. The material covered includes topics from a typical primary school math competition curriculum. Each grade has 25 questions of various difficulty levels and they are arranged from easy to hard in general.',
    }, {
      que: '2. When and where do we get official scores for the World Think Cup?',
      ans: 'Before May 3rd, you will be able to find the score on Think Academy Student app.',
    }, {
      que: '3. How can we prepare for 2022 World Think Cup?',
      ans: `
      <p>We have a set of events for helping you better prepare for the 2022 World Think Cup. Check the follows: </p>
      <p>1)  There are 10 sample questions for each grade on the website. You can refer to the difficulty level and overall style via them. </p>
      <p>2)  From Apr. 5th to Apr. 15th, there will be a mock question daily practice event in each grade’s WeChat group. To join each grade’s WeChat group, please scan the code on the right column of our website. </p>
      <p>3) On Apr. 17th, there will be a mock test.</p>`,
    }, {
      que: '4. My kid’s math skills is in advance of or behind the current school grade. Can I sign up for a different grade?',
      ans: `
      <p>We highly suggest you sign up for the same grade as your kid’s current grade at school, for better competition experience an fairness. Each kid can only sign up for one grade.</p>
      `,
    }, {
      que: '5. I have signed up Think Cup but now i would like to reschedule to another time slot. How to rescheule it?',
      ans: `
      <p>Go to My Courses--> Go to Class Reschedule/Transfer--> Find the Think Cup you have signed up --> Click on Change Class --> Click on Transfer</p>
      `,
    }],
  },
}
